module.exports = __webpack_public_path__ + "static/media/spb (2).d35abcb1.jpg";